import { IBet } from "./service/types";

const getBetKey = ({id}: IBet) => id;

export default getBetKey;
